import './ContactForm.css';

import type { FormInstance }   from 'antd';
import React                   from 'react';
import { Form }                from 'antd';
import { Input }               from 'antd';
import Row                     from 'components/App/Row';
import { Col }                 from 'antd';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import ContactModel            from 'models/ContactModel';
import { messageErrorIntl }    from 'utils/messageIntl';
import { messageSuccessIntl }  from 'utils/messageIntl';
import { AppFormComponent }    from 'components/App/AppForm';

interface ContactFormProps {
  model: ContactModel;
}

class ContactForm extends AppFormComponent<ContactFormProps> {
  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  render() {
    const { model } = this.props;

    return (
      <Form
        className="custom-form"
        initialValues={{
          company: model.get('company'),
          firstname: model.get('firstname'),
          lastname: model.get('lastname'),
          phone: model.get('phone'),
        }}
        ref={this.formRef}
      >
        <Row>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Nom" />}
              labelCol={{ span: 24 }}
              name="lastname"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Renseignez un nom" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Prénom" />}
              labelCol={{ span: 24 }}
              name="firstname"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Renseignez un prénom" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Téléphone" />}
              labelCol={{ span: 24 }}
              name="phone"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Renseignez un numéro" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Société" />}
              labelCol={{ span: 24 }}
              name="company"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Renseignez une société" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const { model } = this.props;

    try {
      const values = await this.formRef.current?.validateFields();
      model.set(values);
      await model.save();
      messageSuccessIntl("Contact enregistré !");
      this.props.onSuccess?.();
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }
  };
}

export default ContactForm;
